import React from "react";
import t from "../../../../i18n";
import NavV2 from "@ui/NavV2";
import Tab from "@ui/NavV2/Tab";
import { toPath, useIsCurrentRouteMatching } from "../../../../router/helpers/path";

function QuantitiesNavigation({ projectId }: { projectId: string }) {
  const isQuantitiesPage = useIsCurrentRouteMatching("/projects/:projectId/settings/quantities");
  const isCrossFiltersPage = useIsCurrentRouteMatching(
    "/projects/:projectId/settings/quantities/crossFilters",
  );

  return (
    <NavV2>
      <Tab
        data-section-id="quantities"
        to={toPath("/projects/:projectId/settings/quantities", { projectId })}
        active={isQuantitiesPage}
      >
        {t("quantities.header.quantities")}
      </Tab>
      <Tab
        data-section-id="crossFilters"
        to={toPath("/projects/:projectId/settings/quantities/crossFilters", { projectId })}
        active={isCrossFiltersPage}
      >
        {t("quantities.header.cross_filters")}
      </Tab>
    </NavV2>
  );
}

export default React.memo(QuantitiesNavigation);
